import { Fingerprint } from "../interfaces/fingerprint";
import { StatusSecurityValidation } from "../interfaces/statusSecurityValidation";

export class Truora {

    private checkId: string;
    private reason: string;
    private riskProfile: string;
    private scoreTruora: number;
    private checkExpeditionDate?: string;
    private requestedBy?: Fingerprint;
    private statusesSecurityValidation?: StatusSecurityValidation[];


    public getCheckId(): string {
        return this.checkId;
    }

    public setCheckId(checkId: string): void {
        this.checkId = checkId;
    }

    public getReason(): string {
        return this.reason;
    }

    public setReason(reason: string): void {
        this.reason = reason;
    }

    public getRiskProfile(): string {
        return this.riskProfile;
    }

    public setRiskProfile(riskProfile: string): void {
        this.riskProfile = riskProfile;
    }

    public getScoreTruora(): number {
        return this.scoreTruora;
    }

    public setScoreTruora(scoreTruora: number): void {
        this.scoreTruora = scoreTruora;
    }

    public getCheckExpeditionDate(): string {
        return this.checkExpeditionDate;
    }

    public setCheckExpeditionDate(checkExpeditionDate: string): void {
        this.checkExpeditionDate = checkExpeditionDate;
    }

    public getRequestedBy(): Fingerprint {
        return this.requestedBy;
    }

    public setRequestedBy(requestedBy: Fingerprint): void {
        this.requestedBy = requestedBy;
    }

    public getStatusesSecurityValidation(): StatusSecurityValidation[] {
        return this.statusesSecurityValidation;
    }

    public setStatusesSecurityValidation(statusesSecurityValidation: StatusSecurityValidation[]): void {
        this.statusesSecurityValidation = statusesSecurityValidation;
    }

    public deserialize(input: any) {
        Object.assign(this, input);

        for (const key in input) {
            if (Object.prototype.hasOwnProperty.call(input, key)) {
                if (this['set' + key.charAt(0).toUpperCase() + key.slice(1)]) {
                    this['set' + key.charAt(0).toUpperCase() + key.slice(1)](input[key]);
                }
            }
        }

        return this;
    }

}
